export default __webpack_public_path__ + "static/benefit1Img-e1b41e2dfe4ac20157690409bb68e582.webp";